module.exports = __webpack_public_path__ + "screenshot.acf3b4119f783c79d75b15fb469ca827.png";